import useSWR from 'swr';
import { Submission } from './types/TaskTypes';
import { fetcherWithToken } from './ApiClient';

// API Response types
export interface FeedResponse {
  results: Submission[];
  meta: {
    pagination: {
      total: number;
      pages: number;
      page: number;
      per_page: number;
      count?: number;
    };
  };
  links: {
    first: string;
    last: string;
    next: string | null;
    prev: string | null;
  };
}

// API functions
const fetchFeed = async (
  page: number,
  authKey?: string
): Promise<FeedResponse> => {
  const queryParams = new URLSearchParams({
    'page[number]': page.toString()
  });

  const url = `${process.env.REACT_APP_DOMAIN}/api/feed/?${queryParams.toString()}`;
  const response = await fetcherWithToken(url, authKey || '');

  // Handle different response formats
  if (response.results && response.meta && response.meta.pagination) {
    const count = response.meta.pagination.count;
    if (typeof count === 'number') {
      response.meta.pagination.total = count;
    }
    return response;
  }

  return response;
};

// Custom hooks
export const useFeed = (
  page: number = 1,
  authKey?: string
) => {
  const shouldFetch = authKey;

  const { data, error, mutate } = useSWR(
    shouldFetch ? [`feed`, page] : null,
    () => fetchFeed(page, authKey),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    data,
    isLoading: !error && !data && shouldFetch,
    isError: error,
    mutate,
  };
};